import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { Drawer, Form } from 'antd';
import { useAuthContext } from '../../../../contexts/AuthContext';
import { useErrorMessage } from '../../../../utils/errorMessage';
import { useFields } from './fields';
import { useGenerateFormItem } from '../../../../utils/generateFormItem';
import { DrawerFormContent } from '../../utils/DrawerFormContent';
import { onFinishForm } from '../utils/onFinishForm';

export const CreateUpdateDrawer = ({
  visible,
  setVisible,
  setRefreshData,
  refreshData,
  subscriptionPrices,
  purpose,
  subscriptionPriceToEdit
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const { dispatchAPI } = useAuthContext();
  const { message } = useErrorMessage();
  const generateFormItem = useGenerateFormItem();
  const { fields } = useFields({
    subscriptionPrices,
    purpose,
    subscriptionPriceToEdit
  });

  const onClose = () => {
    form.resetFields();
    setVisible(false);
  };

  useEffect(() => {
    if (purpose === 'edit') {
      form.setFieldsValue({
        ...subscriptionPriceToEdit,
        application_date: dayjs(subscriptionPriceToEdit.application_date),
        end_date: dayjs(subscriptionPriceToEdit.end_date)
      });
    }
  }, [purpose]);

  return (
    <Drawer
      destroyOnClose
      title={t(`subscription-prices.form.title.drawer.${purpose}`)}
      width={480}
      onClose={onClose}
      visible={visible}
      getContainer={false}
    >
      <DrawerFormContent
        form={form}
        onFinish={(values) =>
          onFinishForm({
            values,
            purpose,
            subscriptionPrices,
            dispatchAPI,
            subscriptionPriceToEdit,
            setVisible,
            setRefreshData,
            refreshData,
            message
          })
        }
        fields={fields}
        generateFormItem={generateFormItem}
        resourceKey="subscription-prices"
        onClose={onClose}
      />
    </Drawer>
  );
};

CreateUpdateDrawer.propTypes = {
  visible: PropTypes.bool,
  setVisible: PropTypes.func,
  setRefreshData: PropTypes.func,
  refreshData: PropTypes.bool,
  supervisionPrice: PropTypes.shape({}).isRequired,
  purpose: PropTypes.string.isRequired,
  subscriptionPriceToEdit: PropTypes.shape({
    application_date: PropTypes.string,
    end_date: PropTypes.string,
    _id: PropTypes.string
  }),
  subscriptionPrices: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

CreateUpdateDrawer.defaultProps = {
  visible: false,
  setVisible: null,
  setRefreshData: null,
  refreshData: false,
  subscriptionPriceToEdit: null
};
